<template>
  <template v-if="context === 'applicant'">
    <p class="py-2">
      Experian requires us to verify your identity to run screening reports. Please read and agree
      to the terms and conditions below.
    </p>
    <p></p
  ></template>

  <template v-else>
    <p class="py-2">
      To be able to request credit reports, you must first verify your identity with Experian.
      <span class="font-semibold">This is NOT a credit check on you.</span>
    </p>
  </template>

  <p class="py-2">
    The entire process happens securely through
    <a
      href="http://www.experian.com/decision-analytics/identity-and-fraud/knowledge-based-authentication.html"
      target="_blank"
      class="text-brand-green cursor-pointer hover:underline"
      >Experian's Knowledge Based Authentication system</a
    >
    and helps reduce fraud.
  </p>

  <textarea
    readonly=""
    resize
    rows="12"
    class="py-5 px-5 my-5 w-full resize-none border border-brand-dark-gray overflow-y-scroll text-xs"
    :value="disclaimerContent"
  >
  </textarea>

  <div class="flex items-center py-5">
    <input
      id="agreeTerms"
      type="checkbox"
      class="h-5 w-5 rounded-sm border-gray-300 text-brand-green focus:ring-brand-green"
      v-model="agreeTerms"
    />
    <label for="agreeTerms" class="ml-5 text-sm"
      >I understand that by checking and clicking on the "I Agree" button immediately following this
      notice, I am:</label
    >
  </div>

  <div class="flex flex-col pl-5">
    <ol class="list-decimal list-outside">
      <li class="text-sm pl-5 py-2">
        Agreeing and consenting to Rent Application's
        <router-link :to="{ name: 'home_terms' }" class="text-brand-green hover:underline"
          >Terms and Conditions.</router-link
        >
      </li>
      <li class="text-sm pl-5 py-2">
        Providing "written instructions" to Rent Application under the Fair Credit Reporting Act
        authorizing Rent Application to obtain information from my personal credit profile or other
        information from Experian,
      </li>
      <li class="text-sm pl-5 py-2">
        Authorizing Rent Application to obtain such information solely to confirm my identity.
      </li>
      <li class="text-sm pl-5 py-2">
        Acknowledging that I have read, understand and received the
        <a
          href="https://connect.experian.com/legal/fcra-obligations.html"
          target="_blank"
          class="text-brand-green hover:underline"
          >Notice to Users of Consumer Reports</a
        >
      </li>
    </ol>

    <div @click="goToInfo" class="py-8 flex w-full md:w-1/3 mx-auto">
      <PrimaryButton :disabled="!agreeTerms">Agree and continue</PrimaryButton>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    context: {
      type: String,
      default: "landlord"
    }
  },
  computed: {
    currentRoute() {
      return this.$route.name
    }
  },
  data() {
    return {
      agreeTerms: false,
      disclaimerContent:
        'You understand that by selecting I AGREE immediately following this notice, you are authorizing Rent Application Technology Services LLC ("Rent Application") to provide your personal information to its third-party identity verification and credit reporting agency providers to verify your identity for the purpose of allowing you to view credit reports ordered by prospective tenants on Rent Application.\n\nYou further acknowledge that you have read and agree to our Terms of Use and specifically represent and warrant:\n\nThat you have never been involved, and will not become involved, in any credit fraud or other unethical business practice;\n\nThat any request for a credit report, and your use of any report obtained through Rent Application, is solely for the purpose of evaluating a rental application; and\n\nThat you will not provide a copy of any report obtained through Rent Application, or any information contained in such a report, to anyone else.'
    }
  },
  methods: {
    goToInfo() {
      if (!this.agreeTerms) return

      if (this.context === "applicant") {
        this.$router.push({ name: "apply_verify_personal_info" })
      } else {
        if (this.currentRoute.includes("flow")) {
          this.$router.push({ name: "flow_listing_verify_personal_info" })
        } else {
          this.$router.push({ name: "dashboard_verify_personal_info" })
        }
      }
    }
  }
}
</script>
